/**
 * 会员等级
 */
import { VIP_LEVEL } from '../types';

export default {
    name: `${VIP_LEVEL}`,
    path: '/VipLevel',
    component: () => import(/* webpackChunkName: 'VipLevel' */ '@/views/vipLevel/'),
    redirect: { name: `${VIP_LEVEL}Index` },
    meta: {
        title: '会员等级',
        // 页签缓存的滚动条位置
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VIP_LEVEL}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'VipLevel' */ '@/views/vipLevel/home/Home.vue'),
        },
        {
            name: `${VIP_LEVEL}Update`,
            path: 'update',
            component: () => import(/* webpackChunkName: 'VipLevel' */ '@/views/vipLevel/create/Create.vue'),
        },
    ],
};
